import { type SelectItem } from './types'
import { DISPOSITION_MODE_OPTIONS, type DispositionMode } from '@terros/common'

export function getDispositionModeLabel(mode: DispositionMode): string {
  if (mode === 'canvass') return 'Canvass'
  if (mode === 'recorder') return 'Skill Insight'
  return 'Canvass & Skill Insight'
}

export const DISPOSITION_MODE_ITEMS: SelectItem<DispositionMode>[] = DISPOSITION_MODE_OPTIONS.map((mode) => ({
  label: getDispositionModeLabel(mode),
  value: mode,
}))
